import React, {useEffect, useState} from 'react';
import { withTranslation } from 'react-i18next';

import './splitPaymentSelector.scss';
import PersonPaymentSelector from './PersonPaymentSelector';
import FormattedPrice from '../../../components/FormattedPrice';

const SplitPaymentSelector = ({ persons, removePerson, updatePerson, orderTotalAmount, amountLeft, t}) => {
  const moreThanOnePayment = persons.length > 1;

  return (
    <div className={'split_payment_selector'}>
      <div className={'payments-list'}>
        {
          persons.map((person, index) => (
            <PersonPaymentSelector
              key={ person.uuid }
              person={ person }
              removePerson={ removePerson }
              updatePerson={ updatePerson }
              moreThanOnePayment={ moreThanOnePayment }
              showCashPayment={ index === 0 }
            />
          ))
        }
      </div>

      { moreThanOnePayment && (amountLeft !== 0 || persons.some(p => !p.amount || p.amount === 0))  && (
        <div className={'left_to_pay'}>
          { amountLeft > 0 && amountLeft <= orderTotalAmount / 100 && (
            <div>
              <span>{ t('payment.left_to_pay') }:</span> <FormattedPrice price={amountLeft * 100} />
            </div>
          ) }

          { amountLeft < 0 && (
            <div>
              <span>{ t('payment.errors.amount_not_equal', { totalAmount:  orderTotalAmount / 100 }) }</span>
            </div>
          ) }

          { persons.some(p => !p.amount || p.amount === 0) && amountLeft === 0 && (
            <div>
              <span>{ t('payment.errors.amount_required') }</span>
            </div>
          ) }


        </div>
      ) }
    </div>
  );
};

export default withTranslation()(SplitPaymentSelector);
